<header>
    <app-menu-header></app-menu-header>
</header>

<router-outlet></router-outlet>

<app-footer></app-footer>
